import { render } from "./SystemComplianceEditor.vue?vue&type=template&id=8082de36"
import script from "./SystemComplianceEditor.vue?vue&type=script&lang=js"
export * from "./SystemComplianceEditor.vue?vue&type=script&lang=js"
script.render = render

export default script